export function QaDashboard() {
	return <div className="space-y-6 p-4">Dashboard</div>;
}
